import { getText } from 'function/language';
import { RESPONSE, RESPONSE_CODE } from 'types/const';

/**
 * 코드에 대한 에러 메시지 반환
 * @param {string} code 코드
 * @param {string} [defaultMessage] 코드에 대한 에러 메시지가 없는 경우 반환할 메시지
 * @return {string} 코드에 대한 에러 메시지
 */
function getErrorMessage(code, defaultMessage) {
  return (
    defaultMessage ??
    getText(RESPONSE[code]) ??
    getText(code) ??
    getText(RESPONSE[RESPONSE_CODE.Error])
  );
}

export { getErrorMessage };
